export function safeParseDate(value: unknown): Date | null {
  if (!value && value !== 0) return null;
  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value;
  }
  if (typeof value === "number" && Number.isFinite(value)) {
    // Heuristic: treat small numbers as seconds
    const milliseconds = value > 10_000_000_000 ? value : value * 1000;
    const parsed = new Date(milliseconds);
    return Number.isNaN(parsed.getTime()) ? null : parsed;
  }
  if (typeof value === "string") {
    const trimmed = value.trim();
    if (!trimmed) return null;
    const numeric = Number(trimmed);
    if (!Number.isNaN(numeric)) {
      const milliseconds = trimmed.length >= 12 ? numeric : numeric * 1000;
      const parsed = new Date(milliseconds);
      if (!Number.isNaN(parsed.getTime())) {
        return parsed;
      }
    }
    const normalised = trimmed.replace(" ", "T");
    const parsed = new Date(normalised);
    if (!Number.isNaN(parsed.getTime())) {
      return parsed;
    }
  }
  return null;
}

export function formatDateTime(value: Date | null, options?: Intl.DateTimeFormatOptions) {
  if (!value) return "—";
  return value.toLocaleString("fr-FR", options ?? { dateStyle: "short", timeStyle: "short" });
}

export function formatDate(value: Date | null, options?: Intl.DateTimeFormatOptions) {
  if (!value) return "—";
  return value.toLocaleDateString("fr-FR", options ?? { year: "numeric", month: "2-digit", day: "2-digit" });
}

export function lightenColor(hex: string, intensity = 0.5) {
  const sanitized = hex.replace("#", "");
  if (sanitized.length !== 6) return hex;
  const num = Number.parseInt(sanitized, 16);
  if (Number.isNaN(num)) return hex;
  const r = (num >> 16) & 0xff;
  const g = (num >> 8) & 0xff;
  const b = num & 0xff;

  const mix = (component: number) => Math.round(component + (255 - component) * intensity);

  const next = (mix(r) << 16) | (mix(g) << 8) | mix(b);
  return `#${next.toString(16).padStart(6, "0")}`;
}

export function normaliseText(value: string) {
  return value.normalize("NFD").replace(/\p{Diacritic}/gu, "").toLowerCase();
}
